export const BUSINESS = {
  name: "PR7 MOT CENTRE",
  tagline: "Adlington • Lancashire",
  phone: "01257 786 540",
  phoneHref: "tel:01257786540",
  email: "bookings@pr7motcentre.co.uk",
  address: "Margaret House, Huyton Road, Adlington, PR7 4HD",
};

export const SERVICES = [
  "MOT",
  "MOT Retest",
  "Wheel Alignment",
  "Full Vehicle Inspection",
  "Interim Service",
  "Full Service",
  "Ford 1.0 EcoBoost Wet Belt",
  "Ford Transit 2.0 Wet Belt",
  "Other",
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "MOT", to: "/mot-testing-adlington" },
  { label: "Servicing", to: "/car-servicing-adlington" },
  { label: "Wet Belts", to: "/ford-wet-belt-replacement" },
  { label: "Vehicle Inspection", to: "/vehicle-inspection" },
  { label: "Cars For Sale", to: "/cars-for-sale" },
  { label: "About Us", to: "/about-us" },
  { label: "Contact", to: "/contact" },
];

export const LOGO = "https://static.prod-images.emergentagent.com/jobs/ad4ff6d6-b64c-4965-91c0-3c8b0c3c7733/images/7818405c52ed560c4feb80660394a41fb3bee058d2f31368ee8d3bae5cc0647b.jpeg";
export const LOGO_FULL = "https://customer-assets-wrfwihn1.emergentagent.net/job_pr7-mot-centre/artifacts/riafmwxn_WhatsApp%20Image%202026-09-18%20at%209.33.00%20PM.jpeg";

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/ad4ff6d6-b64c-4965-91c0-3c8b0c3c7733/images/72644c33673af0f6505a34a653795abf0b238db571c70ee19d84265a29b7e816.jpeg",
  workshop: "https://images.pexels.com/photos/4489776/pexels-photo-4489776.jpeg?auto=compress&cs=tinysrgb&w=1200",
  wetBelt: "https://static.prod-images.emergentagent.com/jobs/ad4ff6d6-b64c-4965-91c0-3c8b0c3c7733/images/fb3e935aac10e5c13ce2a5913297e03832268776bac4e0be952c7c159be2f01d.jpeg",
  engine: "https://static.prod-images.emergentagent.com/jobs/ad4ff6d6-b64c-4965-91c0-3c8b0c3c7733/images/5175f971cc87438807a28da0612bc060806cf68f1f509729177d6554b3d1b1c4.jpeg",
  lift: "https://static.prod-images.emergentagent.com/jobs/ad4ff6d6-b64c-4965-91c0-3c8b0c3c7733/images/84ade7b289766f7b7a09088c392fd9631b90197e528948e67f935231a9b7c129.jpeg",
  brakes: "https://images.pexels.com/photos/34277926/pexels-photo-34277926.jpeg?auto=compress&cs=tinysrgb&w=1200",
  tools: "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
